import { encodingShared } from '@modules/encoding/shared';
import entities from '@shared/entities';

export const useGetStaticMachineries = () => {
    const { currentFarm } = encodingShared.useCurrentFarm();
    const { staticMachineryState } = entities.staticMachinery.useState({ country_id: currentFarm?.country_id });

    return { staticMachineryState };
};
